import type { ReactElement } from 'react'

// いい実装ができず、やや無理やりになっている
// eslint-disable-next-line sonarjs/prefer-read-only-props
export function ExpandableSider({
  visibility,
  sider,
  width,
  body,
}: {
  sider: ReactElement
  body: ReactElement
  visibility: boolean
  width: number
}) {
  return (
    <div className="flex h-full">
      <div
        style={{
          width: visibility ? width : 0,
          height: '100%',
          overflow: 'hidden',
          transition: `all 0.2s`,
        }}
      >
        <div style={{ width }} className="h-full">
          {sider}
        </div>
      </div>
      <div
        style={{
          width: visibility ? `calc(100% - ${width}px)` : '100%',
          transition: `all 0.2s`,
        }}
      >
        {body}
      </div>
    </div>
  )
}
